import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import FormGroup from "./FormGroup";
import DatePicker, {registerLocale, setDefaultLocale} from "react-datepicker";
import Lang from "lang.js";
import messages from "../js/messages";
const lang = new Lang({messages, fallback: "nl"});
import 'react-datepicker/dist/react-datepicker.min.css';

import nl from 'date-fns/locale/nl';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import es from 'date-fns/locale/es';
import it from 'date-fns/locale/it';

import addYears from 'date-fns/addYears';
registerLocale('nl', nl);
registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('es', es);
registerLocale('it', it);

const CustomInput = (props) => {
    return (
        <div className="input-group">
            <input
                style={{
                    backgroundColor: 'transparent',
                }}
                className={props.className}
                onClick={props.onClick}
                value={props.value}
                placeholder={props.placeholder}
                type="text"
                readOnly={false}
            />
            {(!!props.onClear && props.value) ?
                <div style={{
                    color: 'hsl(0,0%,80%)',
                    padding: '8px',
                    boxSizing: 'border-box',
                    position: 'absolute',
                    right: 0,
                }}
                     className="cursor-pointer"
                     onClick={() => props.onClear()}
                >
                    <i className="fa fa-times" aria-hidden="true" height="20" width="20"/>
                </div> : ''}
        </div>
    )
}

const FormGroupDatePicker = (props) => {
    setDefaultLocale(lang.getLocale())

    const {id, name, error, label, prepend, append, noLabel, placeholder, help_text, onChange, autoComplete, readOnly, disabled} = props;

    const pickerRef = useRef(null);

    useEffect(() => {
        pickerRef.current.input.readOnly = true;
    }, [pickerRef]);

    return (
        <>
            {!!props.showTimeSelect &&
                <style>{`.react-datepicker { min-width: 328px; }`}</style>
            }

            <FormGroup
                label={label}
                htmlFor={!!id ? id : name}
                name={name}
                error={error}
                prepend={prepend}
                append={append}
                noLabel={noLabel}
                help_text={help_text}
            >
                <DatePicker
                    // customInput={<CustomInput onClear={props.isClearable ? () => onChange(null) : undefined}/>}
                    autoComplete='off'
                    dropdownMode="select"
                    className={`"form-control" ${!!error && 'is-invalid'}`}
                    placeholderText={!!placeholder ? placeholder : lang.get('portal.' + name)}
                    onChange={onChange}
                    maxDate={addYears(new Date(), 800)}
                    isClearable={false}
                    ref={pickerRef}
                    {...props}
                />
            </FormGroup>
        </>
        );
}

export default FormGroupDatePicker;

FormGroupDatePicker.propTypes = {
    noLabel: PropTypes.bool,
    autoComplete: PropTypes.string,
    label: PropTypes.string,
    autoFocus: PropTypes.bool,
    calendarClassName: PropTypes.string,
    calendarContainer: PropTypes.func,
    chooseDayAriaLabelPrefix: PropTypes.string,
    className: PropTypes.string,
    customInput: PropTypes.element,
    disabled: PropTypes.bool,
    disabledKeyboardNavigation: PropTypes.bool,
    dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
    endDate: PropTypes.instanceOf(Date),
    id: PropTypes.string,
    inline: PropTypes.bool,
    isClearable: PropTypes.bool,
    locale: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({locale: PropTypes.object})
    ]),
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool,
    openToDate: PropTypes.instanceOf(Date),
    placeholderText: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    // selected: PropTypes.instanceOf(Date),
    help_text: PropTypes.node,
}

FormGroupDatePicker.defaultProps = {
    dateFormat: "dd-MM-yyyy HH:mm",
    input_class: '',
    className: 'form-control',
    isCreatable: false,
    showTimeSelect: false,
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: "select",
    autoComplete: "off",
    disabled: false,
    disabledKeyboardNavigation: true,
};
